import styled from '@emotion/styled';

import { LocalizedLink } from '../LocalizedLink/LocalizedLink';

interface LinkProps {
  isActive?: boolean;
}

export const StyledHeader = styled.header`
  background: var(--color-white);
  padding-block: var(--spacing-12);
  box-shadow: var(--elevation-20);
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1536px;
  color: var(--color-black);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-inline: auto;
  padding-inline: var(--spacing-24);
`;

export const Group = styled.div`
  min-height: var(--spacing-40);
  display: flex;
  align-items: center;
  gap: var(--spacing-20);
`;

export const Nav = styled.nav`
  display: none;
  align-items: center;
  gap: var(--spacing-12);

  @media (min-width: 1200px) {
    display: flex;
  }
`;

export const StyledLink = styled(LocalizedLink, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<LinkProps>`
  position: relative;
  padding: var(--spacing-8) var(--spacing-12) var(--spacing-8) var(--spacing-16);
  border-radius: var(--border-radius-s);
  transition: background 0.3s;
  font: var(--font-body-xl-bold);
  color: inherit;
  text-decoration: none;

  &:hover {
    background: var(--color-neutral-20);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline-width: 2px;
    outline-style: solid;
    outline-color: initial;
  }

  &:after {
    position: absolute;
    background: var(--color-black);
    width: 100%;
    height: 2px;
    left: 0;
    bottom: 0;
    margin-bottom: calc(var(--spacing-12) * -1);
  }

  ${({ isActive }) =>
    isActive &&
    `
      &::after {
        content: '';
      }
    `}
`;
